import React from 'react'
import loadable from '@loadable/component'
import Layout from '../layout/layout'

function Loading() {
  return <div>Loading...</div>
}

// ======= Dashboard ===============
const Dashboard = loadable(() => import('features/dashboard/dashboard'), {
  fallback: <Loading />,
})

// ======= DeviceList =============
// Don't show DeviceList on public routes

// ======= Panic ===============
const OngoingDashboard = loadable(
  () => import('features/panic/ongoing-dashboard'),
  { fallback: <Loading /> }
)
const OngoingLiveFeed = loadable(
  () => import('features/panic/ongoing-live-feed'),
  { fallback: <Loading /> }
)
const ResolvedDashboard = loadable(
  () => import('features/panic/resolved-dashboard'),
  { fallback: <Loading /> }
)
const ResolvedHistory = loadable(
  () => import('features/panic/resolved-history'),
  { fallback: <Loading /> }
)

// ======= Profile ===============
const Profile = loadable(() => import('features/profile/profile'), {
  fallback: <Loading />,
})

// ======= Reports ===============
const ActiveSitRep = loadable(() => import('features/sit-rep/active-sitrep'), {
  fallback: <Loading />,
})
const ActiveReport = loadable(
  () => import('features/sit-rep/outlets/active-report'),
  { fallback: <Loading /> }
)
const ArchivedSitrep = loadable(
  () => import('features/sit-rep/archived-sitrep'),
  { fallback: <Loading /> }
)
const ArchivedReport = loadable(
  () => import('features/sit-rep/outlets/archived-report'),
  { fallback: <Loading /> }
)

// ======= Summons ===============
const IssuedDashboard = loadable(
  () => import('features/summons/issued/issued-dashboard'),
  { fallback: <Loading /> }
)
const IssuedHistory = loadable(
  () => import('features/summons/issued/issued-history'),
  { fallback: <Loading /> }
)
const IssuedPrintPreview = loadable(
  () => import('features/summons/issued/issued-print-preview'),
  { fallback: <Loading /> }
)
const RejectedDashboard = loadable(
  () => import('features/summons/rejected/rejected-dashboard'),
  { fallback: <Loading /> }
)
const RejectedHistory = loadable(
  () => import('features/summons/rejected/rejected-history'),
  { fallback: <Loading /> }
)
const VerifiedDashboard = loadable(
  () => import('features/summons/verified/verified-dashboard'),
  { fallback: <Loading /> }
)
const VerifiedHistory = loadable(
  () => import('features/summons/verified/verified-history'),
  { fallback: <Loading /> }
)
const TrafficOffences = loadable(
  () => import('features/summons/offences/traffic-offences'),
  { fallback: <Loading /> }
)

// ======= Touring ===============
const HistoryDashboard = loadable(
  () => import('features/touring/history/history-dashboard'),
  { fallback: <Loading /> }
)
const HistoryRecord = loadable(
  () => import('features/touring/history/history-record'),
  { fallback: <Loading /> }
)
const HistoryInTourReport = loadable(
  () => import('features/touring/history/history-in-tour-report'),
  { fallback: <Loading /> }
)
const HistoryPrintPreview = loadable(
  () => import('features/touring/history/history-print-preview'),
  { fallback: <Loading /> }
)
const LiveTourDashboard = loadable(
  () => import('features/touring/live/live-tour-dashboard'),
  { fallback: <Loading /> }
)
const LiveTourFeed = loadable(
  () => import('features/touring/live/live-tour-feed'),
  { fallback: <Loading /> }
)

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: Layout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },

  { path: '/profile', exact: true, name: 'Profile', component: Profile },

  {
    path: '/touring/live',
    exact: true,
    name: 'Live',
    component: LiveTourDashboard,
  },
  {
    path: '/touring/live/details',
    exact: true,
    name: 'Active',
    component: LiveTourFeed,
  },
  {
    path: '/touring/history',
    exact: true,
    name: 'Tour History',
    component: HistoryDashboard,
  },
  {
    path: '/touring/history/details',
    exact: true,
    name: 'Log',
    component: HistoryRecord,
  },
  {
    path: '/touring/history/details/report',
    exact: true,
    name: 'Report',
    component: HistoryInTourReport,
  },
  {
    path: '/touring/history/historyprint',
    exact: true,
    name: 'History Print',
    component: HistoryPrintPreview,
  },

  {
    path: '/reports/active',
    exact: true,
    name: 'Active Reports',
    component: ActiveSitRep,
  },
  {
    path: '/reports/active/view',
    exact: true,
    name: 'View',
    component: ActiveReport,
  },
  {
    path: '/reports/archived',
    exact: true,
    name: 'Archived Reports',
    component: ArchivedSitrep,
  },
  {
    path: '/reports/archived/view',
    exact: true,
    name: 'View',
    component: ArchivedReport,
  },

  {
    path: '/panic/ongoing',
    exact: true,
    name: 'Ongoing Panics',
    component: OngoingDashboard,
  },
  {
    path: '/panic/ongoing/details',
    exact: true,
    name: 'Active',
    component: OngoingLiveFeed,
  },
  {
    path: '/panic/resolved',
    exact: true,
    name: 'Resolved Panics',
    component: ResolvedDashboard,
  },
  {
    path: '/panic/resolved/details',
    exact: true,
    name: 'Log',
    component: ResolvedHistory,
  },
]

const getPublicRoutes = ({ summon }) => {
  if (summon) {
    routes.push({
      path: '/offences',
      exact: true,
      name: 'Traffic Offences',
      component: TrafficOffences,
    })

    routes.push({
      path: '/traffic/issued',
      exact: true,
      name: 'Compound Issued',
      component: IssuedDashboard,
    })
    routes.push({
      path: '/traffic/issued/details',
      exact: true,
      name: 'Info',
      component: IssuedHistory,
    })
    routes.push({
      path: '/traffic/issued/print',
      exact: true,
      name: 'Info',
      component: IssuedPrintPreview,
    })
    routes.push({
      path: '/traffic/verified',
      exact: true,
      name: 'Compound Verified',
      component: VerifiedDashboard,
    })
    routes.push({
      path: '/traffic/verified/details',
      exact: true,
      name: 'Info',
      component: VerifiedHistory,
    })
    routes.push({
      path: '/traffic/archived',
      exact: true,
      name: 'Compound Archived',
      component: RejectedDashboard,
    })
    routes.push({
      path: '/traffic/archived/details',
      exact: true,
      name: 'Info',
      component: RejectedHistory,
    })
  }

  return routes
}

export default getPublicRoutes
